module.exports = __webpack_public_path__ + "static/media/cms-mvv-logo.21cb17ae.png";